import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { CallService } from 'src/app/services/http/call/call.service';
import { UtilsService } from 'src/app/services/tools/utils.service';
import { InstallationsService } from 'src/app/services/http/installations/installations.service';
import { InstallListOwner } from 'src/app/model/installations/installations.model';

@Component({
  selector: 'app-list-install-owner',
  templateUrl: './list-install-owner.component.html',
  styleUrls: ['./list-install-owner.component.scss']
})
export class ListInstallOwnerComponent implements OnInit {

  public startCP: any;
  public endCP: any;


  get displayedColumnInstallOwner(): string[] {
    const result: string[] = ['numeroSerie', 'dateInstallation','nomInstallation','raisonSociale','codeEbp','prenom','nom','adresse','complementAdresse','codePostal','ville','pays'];
    return result;
  }

  constructor(private service: CallService,
    private utils: UtilsService,
    private router: Router,
    private installations: InstallationsService) { }

  /**
   * Boolean indicating if spinner has to be shown while something is being loaded
   */
  public isLoading: boolean = false;



  /**
   * List of installations with their owner
   */
  listinstallowner !: InstallListOwner[];

  ngOnInit(): void {

    this.getList();

   
  }

  public getNiceDate(date: string) {
    return this.utils.getNiceDate(date);
  }

  public getList(){
    this.isLoading = true;
    this.installations.getInstallOwnerList().subscribe((installs) => {
      this.listinstallowner = installs;});
      this.isLoading = false;
  }

  clickRow(row : InstallListOwner){
    this.router.navigate(['installation', row.ID_INSTALLATION]);
  }



  

}
